import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-83">
      <div className="max-w-4xl mx-auto text-center" data-id="element-84">
        {/* Logo */}
        <div className="text-[#FFD700] text-3xl font-black tracking-widest mb-8" data-id="element-85">
          🎵 PROFEPACK
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-86">
          El próximo domingo podés seguir buscando material en Google.
        </h2>
        <p className="text-[#FFD700] text-2xl sm:text-3xl font-black mb-10" data-id="element-87">
          O podés tener todo resuelto desde hoy.
        </p>

        {/* Countdown */}
        <div className="mb-4" data-id="element-88">
          <p className="text-white font-bold mb-4" data-id="element-89">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-90" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-91">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-92">$10.000 ARS</span> y no
          vuelve.
        </p>

        {/* 3 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10" data-id="element-93">
          <div className="bg-[#0d0d00] border-2 border-[#FFD700] rounded-xl p-5 text-center shadow-[0_0_30px_rgba(255,215,0,0.2)]" data-id="element-94">
            <div className="text-2xl mb-2" data-id="element-95">🏆</div>
            <h3 className="text-[#FFD700] font-black mb-1" data-id="element-96">PACK COMPLETO ⭐</h3>
            <p className="text-[#FFD700] text-3xl font-black mb-4" data-id="element-97">
              $27.990 ARS
            </p>
            <a href="https://www.profepack.com/cart/47599804809472:1" className="btn-gold-pulse block bg-[#FFD700] text-black font-black py-4 rounded-lg hover:bg-yellow-300 transition-colors text-sm" data-id="element-98">
              → QUIERO MI PROFEPACK
            </a>
          </div>
          <div className="bg-[#0a0a0a] border border-[#FFD700]/30 rounded-xl p-5 text-center" data-id="element-99">
            <div className="text-2xl mb-2" data-id="element-100">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-101">PRIMARIA</h3>
            <p className="text-[#FFD700] text-2xl font-black mb-4" data-id="element-102">
              $16.990 ARS
            </p>
            <a href="https://www.profepack.com/cart/48106544300288:1" className="btn-gold-pulse block bg-[#FFD700] text-black font-black py-4 rounded-lg hover:bg-yellow-300 transition-colors text-sm" data-id="element-103">
              → QUIERO PRIMARIA
            </a>
          </div>
          <div className="bg-[#0a0a0a] border border-[#FFD700]/30 rounded-xl p-5 text-center" data-id="element-104">
            <div className="text-2xl mb-2" data-id="element-105">📗</div>
            <h3 className="text-white font-black mb-1" data-id="element-106">SECUNDARIA</h3>
            <p className="text-[#FFD700] text-2xl font-black mb-4" data-id="element-107">
              $18.990 ARS
            </p>
            <a href="https://www.profepack.com/cart/48106544333056:1" className="btn-gold-pulse block bg-[#FFD700] text-black font-black py-4 rounded-lg hover:bg-yellow-300 transition-colors text-sm" data-id="element-108">
              → QUIERO SECUNDARIA
            </a>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-109">
          <span data-id="element-110">🔒 Pago 100% seguro</span>
          <span data-id="element-111">⚡ Acceso en 5 minutos</span>
          <span data-id="element-112">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-113">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}